import { render, staticRenderFns } from "./Smallpox.vue?vue&type=template&id=9794bd40&"
import script from "./Smallpox.vue?vue&type=script&lang=js&"
export * from "./Smallpox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports